//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NsCurrency from "./NsCurrency.vue";

/**
 * How to use: 'original' price should be retail, except during a sale and the
 * user is logged in, then show wholesale. 'price' is the actual selling price
 * (retail, wholesale, sale, etc.). Always shows selling price. If original
 * price is different and 'showOriginalCrossedOut' is true it will show the
 * original price crossed out. By default, ADR price is only shown if its value
 * is different than the selling price.
 */
export default {
  name: "NsProductPrice",
  components: { NsCurrency },
  props: {
    /**
     * Will show only the Adr Price and label
     */
    adrOnly: Boolean,
    /**
     * The ADR Price
     */
    adrPrice: {
      type: String,
      default: ""
    },
    /**
     * The Label for ADR Price
     */
    adrPriceLabel: {
      type: String,
      default: ""
    },
    /**
     * The priceType of the ADR amount
     */
    adrPriceType: {
      type: String,
      default: ""
    },
    /**
     * If true, will override hiding all components associated with ADR
     */
    hideAdrOverride: Boolean,
    /**
     * If true, will show minPrice and maxPrice if different.
     */
    isBaseSku: Boolean,
    /**
     * Min Actual Price (if base sku)
     */
    minPrice: {
      type: String,
      default: ""
    },
    /**
     * Max Actual Price (if base sku)
     */
    maxPrice: {
      type: String,
      default: ""
    },
    /**
     * Retail Price
     */
    originalPrice: {
      type: String,
      default: ""
    },
    /**
     * Label for Retail Price
     */
    originalPriceLabel: {
      type: String,
      default: ""
    },
    /**
     * The priceType of the original amount
     */
    originalPriceType: {
      type: String,
      default: ""
    },
    /**
     * Actual price for user
     */
    price: {
      type: String,
      default: ""
    },
    /**
     * Label for actual price type (Wholesale, Retail Sale, etc.)
     */
    priceLabel: {
      type: String,
      default: ""
    },
    /**
     * The priceType of the amount
     */
    priceType: {
      type: String,
      default: ""
    },
    /**
     * If true, will show the ADR price, even if it's the same as price
     */
    showAdrPrice: Boolean,
    /**
     * If true, will show price labels
     */
    showLabels: Boolean,
    /**
     * If true, will show original price crossed out
     */
    showOriginalCrossedOut: Boolean
  },
  computed: {
    showOriginal() {
      return (
        !this.isBaseSku &&
        this.showOriginalCrossedOut &&
        this.originalPrice > this.price
      );
    },

    showMinMax() {
      return this.isBaseSku && this.minPrice !== this.maxPrice;
    },

    showAdr() {
      return (
        !this.hideAdrOverride &&
        this.adrPrice &&
        (this.showAdrPrice || this.adrPrice !== this.price || this.adrOnly)
      );
    }
  }
};
